import { render, staticRenderFns } from "./EffectiveList.vue?vue&type=template&id=6ade072e&scoped=true"
import script from "./EffectiveList.vue?vue&type=script&lang=js"
export * from "./EffectiveList.vue?vue&type=script&lang=js"
import style0 from "./EffectiveList.vue?vue&type=style&index=0&id=6ade072e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade072e",
  null
  
)

export default component.exports